import React from "react";
import Pagination from "./Pagination";
import Moment from "moment";

const Table = ({
  columns,
  data,
  tableRef,
  pageSize,
  setPageSize,
  currentPage,
  totalCount,
  onPageChange,
  handleSearchChange,
  closing_balance,
  closingBalanceType,
  handleEdit,
  handlePDF,
  handleView,
  handleDelete,
  handleAddOpeningBalance,
  handleGenerateEinvoice,
  showDateFilters,
  fromDate,
  toDate,
  setFromDate,
  setToDate,
  resetDates,
  handleSubmit,
  handleSubmitPdf,
  handleLedger,
  setSelectedRows,
  selectedRows,
  selectAll,
  setSelectAll,
  totalPendingAmount,
  totalPaidAmount,
  minDate,
  maxDate,
  totalfor,
  formattedTotalCurrentStockValue,
}) => {
  const handlePageSizeChange = (e) => {
    setPageSize(Number(e.target.value));
  };

  const handleCheckboxChange = (event, rowId) => {
    // console.log('rowId', rowId);
    let updatedSelection = [...selectedRows];

    if (event.target.checked) {
      updatedSelection.push(rowId); // Add ID if checked
    } else {
      updatedSelection = updatedSelection?.filter((id) => id !== rowId); // Remove ID if unchecked
    }

    setSelectedRows(updatedSelection);
    setSelectAll(updatedSelection?.length === data?.length); // Check if all are selected
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const allRowIds = data?.map((row) => row.id); // Select all IDs
      setSelectedRows(allRowIds);
    } else {
      setSelectedRows([]);
    }
    setSelectAll(event.target.checked);
  };

  const indexOfLastItem = currentPage * pageSize;
  const indexOfFirstItem = indexOfLastItem - pageSize;
  const currentItems = data?.slice(indexOfFirstItem, indexOfLastItem);

  const renderCellContent = (column, row) => {
    if (typeof column.render === "function") {
      return column.render(row);
    }

    const formatAmount = (value) => {
      return new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    };

    if (column.isAction) {
      const actionButtons = column.getActionButtons
        ? column.getActionButtons(row)
        : column.actionButtons || [];
      return (
        <>
          {actionButtons?.map((button, index) => (
            <button
              key={index}
              className={`btn-sm ${button.className}`}
              style={
                button.className === "btn-default"
                  ? { marginBottom: "5px" }
                  : {}
              }
              onClick={() => {
                if (button.name === "Edit") {
                  handleEdit(row);
                } else if (button.name === "Add Grant") {
                  handleEdit(row);
                } else if (button.name === "View Ledger Entries") {
                  handleView(row);
                } else if (button.name === "Opening Balance") {
                  if (typeof handleAddOpeningBalance === "function") {
                    handleAddOpeningBalance(row);
                  }
                } else if (button.name === "View Item Ledger") {
                  handleLedger(row);
                } else if (button.name === "Delete") {
                  handleDelete(row);
                } else if (button.name === "View Logs Details") {
                  handleView(row);
                } else if (button.icon) {
                  handlePDF(row);
                } else if (button.name === "View Invoice") {
                  handleView(row);
                } else if (button.name === "Generate E-invoice") {
                  handleGenerateEinvoice(row);
                }
              }}
            >
              {button.name}
              {button.icon}
            </button>
          ))}
        </>
      );
    }

    switch (column.field) {
      case "Checkbox":
        return (
          <input
            type="checkbox"
            checked={selectedRows?.includes(row.id ?? row.item_id)}
            onChange={(e) => handleCheckboxChange(e, row.id ?? row.item_id)}
            style={{ marginRight: "10px" }}
          />
        );
  //       case "calculated_total":
  // const quantity = parseFloat(row["Quantity"]) || 0;
  // const price = parseFloat(row["PricePerUnit"]) || 0;
  // const total = quantity * price;
  // return (
  //   <span style={{ textAlign: "right", display: "block" }}>
  //     {formatAmount(total)}
  //   </span>
  // );

      case "invoice_combined":
        return row.invoice_prefix == null
          ? `${row.invoice_number}`
          : `${row.invoice_prefix}${row.invoice_number}`;
      case "balance_combined":
        const balance =
          row.opening_balance && row.opening_balance !== "0.00"
            ? row.opening_balance
            : "";
        const drCr =
          row.dr_cr && row.opening_balance && row.opening_balance !== "0.00"
            ? row.dr_cr
            : "";

        return (
          <span>
            {balance} {drCr}
          </span>
        );
      case "closing_combined":
        const balance1 =
          row.closing_balance && row.closing_balance !== "0.00"
            ? row.closing_balance
            : "";
        const drCr1 =
          row.closing_balance_type &&
          row.closing_balance &&
          row.closing_balance !== "0.00"
            ? row.closing_balance_type
            : "";

        return (
          <span>
            {balance1} {drCr1}
          </span>
        );

        // Ensure formatAmount is applied only to the numeric balance
        const formattedBalance = balance !== "" ? formatAmount(balance) : "";

        return `${formattedBalance} ${drCr}`.trim();

      case "quotation_combined":
        if (row.quotation_prefix == null) return `${row.quotation_number}`;
        return `${row.quotation_prefix}${row.quotation_number}`;
      case "low_stock_combined":
        if (row.low_stock_value == null || row.unit == null) return "";
        return `${row.low_stock_value} ${row.unit}`;

      case "current_stock_combined":
        if (row.unit == null) return `${row.current_stock}`;
        return `${row.current_stock} ${row.unit}`;
        

      case "total_sold_combined":
        if (row.total_sold == null || row.unit == null) return "";
        return `${row.total_sold} ${row.unit}`;

      case "current_stock":
        if (row.unit == null) return `${row.current_stock}`;
        return `${row.current_stock} ${row.unit}`;

      case "opening_stock_qty":
        if (row.unit == null) return `${row.opening_stock_qty}`;
        return `${row.opening_stock_qty} ${row.unit}`;

      // case 'current_stock_value':
      //     if (row.current_stock_value == null || row.unit == null) return '';
      //     return `${row.current_stock_value} ${row.unit}`;
      case "TransactionDate":
      case "added_on":
      case "date_of_appointment":
      case "ack_date":
      case "po_date":
      case "InvoiceDate":
      case "date_added":
      case "payment_date":
      case "quotation_date":
      case "debit_note_date":
      case "ledger_date":
      case "closing_date":
      case "bill_date":
      case "opening_date":
      case "invoice_date":
        return row[column.field]
          ? Moment(row[column.field]).format("DD-MM-YYYY")
          : " ";
      case "created_at":
        return Moment(row.created_at).format("DD-MM-YYYY  HH:mm:ss");
      case "dr":
        return Number(row[column.field]) === 0 ? (
          ""
        ) : (
          <span style={{ textAlign: "right", display: "block" }}>
            {formatAmount(row[column.field])}
          </span>
        );
      case "cr":
        return Number(row[column.field]) === 0 ? (
          ""
        ) : (
          <span style={{ textAlign: "right", display: "block" }}>
            {formatAmount(row[column.field])}
          </span>
        );
      case "amount":
      case "grand_total":
      case "cgst":
      case "sgst":
      case "igst":
      case "pending_amount":
      case "TotalCost":
      case "PricePerUnit":
      case "InvoiceValue":
      case "CGSTAmount":
      case "TaxableValue":
      case "SGSTAmount":
      case "IGSTAmount":
      case "TotalTaxAmount":
      case "ItemTotal":
      case "opening_stock_value":
      case "debit_amount":
      case "credit_amount":
      case "avg_purchase_price":
      case "current_stock_value":
      case "total_amount":
      case "item_total_cost":
      case "sale_price":
        return (
          <span style={{ textAlign: "right", display: "block" }}>
            {formatAmount(row[column.field])}
          </span>
        );
      case "purchase_price":
        return (
          <span style={{ textAlign: "right", display: "block" }}>
            {formatAmount(row[column.field])}
          </span>
        );
      case "balance":
        return (
          <span style={{ textAlign: "right", display: "block" }}>
            {formatAmount(row[column.field])}
          </span>
        );
      case "paid_amount":
      case "balance_amount":
        return (
          <span
            style={{
              textAlign: "right",
              display: "block",
              color: row["balance_amount"] === 0 ? "green" : "inherit",
            }}
          >
            {formatAmount(Math.abs(row[column.field]))}
          </span>
        );

    case "description":
  const trimmedDescription = row[column.field].trim();
  return (
    <>
      {trimmedDescription.split("\n").map((line, index) => (
        <React.Fragment key={index}>
          {line}
          <br />
        </React.Fragment>
      ))}
      { row.counter_ledger_name && (
        <>
         <strong>Ledger:</strong> {row.counter_ledger_name}
        </>
      )}
    </>
  );
      default:
        return row[column.field];
    }
  };

  return (
    <div className="card custom-card mb-4">
      {showDateFilters && ( // Conditionally render the date filter section
        <div class="card custom-card">
          <div class="card-body">
            <div className="row">
              <div className="col-md-3 form-inline">
                <div className="form-group">
                  <label>From Date</label>
                  <input
                    className="form-control"
                    type="date"
                    value={fromDate}
                    onChange={setFromDate}
                    min={minDate}
                    max={maxDate}
                  />
                </div>
              </div>
              <div className="col-md-3 form-inline">
                <div className="form-group">
                  <label>To Date</label>
                  <input
                    className="form-control"
                    type="date"
                    value={toDate}
                    onChange={setToDate}
                    min={minDate}
                    max={maxDate}
                  />
                </div>
              </div>
              <div className="col-md-6 form-inline">
                <div className="form-group">
                  <button
                    type="submit"
                    className="btn btn-default"
                    onClick={handleSubmit}
                  >
                    Submit
                  </button>
                </div>
                <div class="form-group">
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={resetDates}
                  >
                    Reset Date
                  </button>
                </div>
                <div class="form-group">
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={handleSubmitPdf}
                  >
                    Ledger PDF
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {data?.length === 0 && !handleSearchChange ? (
        <div className="card-body">
          <h2 className="text-center">No Record Found!!</h2>
        </div>
      ) : (
        <div className="card-body">
          <div className="row mb-3">
            <div className="col-md-6">
              <label>
                <select
                  name="pageSize"
                  value={pageSize}
                  onChange={handlePageSizeChange}
                  className="form-select"
                >
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                &nbsp;items/page
              </label>
            </div>
            <div className="col-md-6">
              <input
                type="search"
                className="form-control"
                placeholder="Search..."
                style={{ float: "right", width: "auto" }}
                onChange={handleSearchChange}
              />
            </div>
          </div>
          {closing_balance &&
          parseFloat(closing_balance.replace(/[^0-9.-]/g, "")) >= 0 ? (
            <div
              className="text-right"
              style={{
                padding: "10px 0",
                fontWeight: "700",
                fontSize: "18px", // Increased font size
              }}
            >
              Closing Balance {closingBalanceType} : ₹ {closing_balance}
            </div>
          ) : null}

          {data?.length === 0 ? (
            <h2 className="text-center">No Record Found!!</h2>
          ) : (
            <div style={{ overflowX: "auto" }}>
              <table
                className="table table-bordered border-bottom"
                ref={tableRef}
              >
                <thead className="table-header">
                  <tr>
                    {columns?.map((column) => (
                      <th
                        key={column?.field}
                        style={{
                          width:
                            column?.field === "added_on" ||
                            column?.field === "payment_date" ||
                            column?.field === "invoice_date" ||
                            column?.field === "InvoiceDate"
                              ? "8rem "
                              : "auto",
                          textAlign: [
                            "amount",
                            "grand_total",
                            "debit_amount",
                            "credit_amount",
                            "avg_purchase_price",
                            "current_stock_value",
                            "total_amount",
                            "item_total_cost",
                            "sale_price",
                            "purchase_price",
                            "balance",
                            "cr",
                            "dr",
                            "cgst",
                            "sgst",
                            "igst",
                            "pending_amount",
                          ].includes(column?.field)
                            ? "right"
                            : "left",
                        }}
                      >
                        {column?.field === "Checkbox" ? (
                          <input
                            type="checkbox"
                            checked={selectAll}
                            onChange={handleSelectAll}
                            style={{ marginRight: "10px" }}
                          />
                        ) : (
                          column?.header
                        )}
                      </th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {currentItems?.map((row, rowIndex) => (
                    <tr key={rowIndex}>
                      {columns.map((column, colIndex) => (
                        <td
                          key={colIndex}
                          style={
                            column?.actionButtons ? { textAlign: "center" } : {}
                          }
                        >
                          {renderCellContent(column, row)}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
                {(totalPendingAmount !== undefined && totalPendingAmount !== null) ||
                (totalPaidAmount !== undefined && totalPaidAmount !== null) ? (
                  <tfoot>
                    <tr>
                      {columns.map((column, index) => {
                        // First cell carries the label to keep alignment with the header
                        if (index === 0) {
                          return (
                            <td key={`footer-${index}`} style={{ fontWeight: "700" }}>
                              Total
                            </td>
                          );
                        }

                        // When `totalfor` is true we only have one numeric column to total
                        if (totalfor) {
                          if (index === columns.length - 2) {
                            return (
                              <td
                                key={`footer-${index}`}
                                style={{ fontWeight: "700", textAlign: "right" }}
                              >
                                {totalPaidAmount ?? totalPendingAmount ?? ""}
                              </td>
                            );
                          }

                          return <td key={`footer-${index}`}></td>;
                        }

                        // Default mode: place pending and paid totals in the last two columns
                        if (index === columns.length - 2) {
                          return (
                            <td
                              key={`footer-${index}`}
                              style={{ fontWeight: "700", textAlign: "right" }}
                            >
                              {totalPendingAmount ?? ""}
                            </td>
                          );
                        }

                        if (index === columns.length - 1) {
                          return (
                            <td
                              key={`footer-${index}`}
                              style={{ fontWeight: "700", textAlign: "right" }}
                            >
                              {totalPaidAmount ?? ""}
                            </td>
                          );
                        }

                        return <td key={`footer-${index}`}></td>;
                      })}
                    </tr>
                  </tfoot>
                ) : null}
                {formattedTotalCurrentStockValue && (
                  <tfoot>
                    <tr>
                      <td
                        colSpan={columns.length - 2}
                        style={{ textAlign: "right", fontWeight: "700" }}
                      >
                        Total Current Stock Value:
                      </td>
                      <td style={{ textAlign: "right", fontWeight: "700" }}>
                        {formattedTotalCurrentStockValue}
                      </td>
                    </tr>
                  </tfoot>
                )}
              </table>
              <div className="PaginationContainer">
                <span className="total-elements">
                  Showing {indexOfFirstItem + 1} to{" "}
                  {Math.min(indexOfLastItem, totalCount)} of {totalCount}{" "}
                  entries
                </span>
                <Pagination
                  currentPage={currentPage}
                  totalCount={totalCount}
                  itemsPerPage={pageSize}
                  onPageChange={onPageChange}
                />
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Table;
